import React from 'react';
import { observer, Observer, inject } from 'mobx-react';
import { toJS, action, autorun, observable, computed } from 'mobx';
import moment from 'moment';

import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import 'rc-tooltip/assets/bootstrap.css';

import { SiteHeader } from '../component/SiteHeader';
import { SiteFooter } from '../component/SiteFooter';
import { PreventParentScroll } from '../component/PreventParentScroll';
import { Focuspoint } from '../component/Focuspoint';
import { Dropdown } from '../component/Dropdown';
import { DayPicker } from '../component/DayPicker';
import { Swiper } from '../component/Swiper';
import { GoogleMap, MarkerWithInfoWindow, MarkerIconSVG } from '../component/GoogleMap';
import * as constants from '../../model/const';
import { StickInParent } from '../component/StickInParent';

import { fmtPrice, fmtPercent, fmtDatetime, fmtDate, fmtTime } from '../../model/formatters';
import { replaceBetween } from '../../utils';
import translateBase from '../../translate';
let translate = translateBase.bindPage('search');

const google = window.google;
const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Range = createSliderWithTooltip(Slider.Range);

@inject(stores => ({
  navigation: stores.app.navigation,
  organization: stores.app.organization,
  vSearch: stores.app.vSearch,
  searchForm: stores.app.searchForm,
  masterData: stores.app.masterData,
  searchResults: stores.app.searchResults,
  businessUnit: stores.app.businessUnit,
  aggParameters: stores.app.aggParameters,
}))
@observer
export class Search extends React.Component {

  handleScroll = (event) => {
    this.props.vSearch.handleScroll(window.scrollY);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  @action.bound resetAllParameters() {
    this.props.searchForm.resetAllParameters();
  }

  @observable shownPointLat;
  @observable shownPointLon;

  timeoutHandle;

  @action.bound showPoint(lat, lon) {
    if (this.props.vSearch.showsMap) {
      let timeoutHandle;
      if (!lat || !lon) {
        // return
      }
      if (this.timeoutHandle !== undefined) {
        clearTimeout(this.timeoutHandle);
        this.timeoutHandle = undefined;
      }
      this.timeoutHandle = setTimeout(action(() => {
        if (this.shownPointLat !== lat || this.showPointLon !== lon) {
          this.shownPointLat = lat;
          this.shownPointLon = lon;
        }
      }), 10)
    }
  }

  @computed get geoCentre() {
    if (this.shownPointLat && this.shownPointLon) {
      return {
        lat: this.shownPointLat,
        lng: this.shownPointLon,
      }
    }
    const items = this.props.searchResults.filteredItems;
    if (items.length === 0) {
      return { lat: 47.44189058, lng: 8.43409091 };
    }
    let sumLat = 0;
    let sumLon = 0;
    for (let result of items) {
      sumLat += result.lat;
      sumLon += result.lon;
    }
    return {
      lat: sumLat / items.length,
      lng: sumLon / items.length,
    }
  }

  @computed get allCoords() {
    const items = this.props.searchForm.distinctLocations;
    if (items.length === 0) {
      return [{ lat: 47.44189058, lng: 8.43409091, locationId: '', locationName: '' }];
    }
    else {
      let alreadyHave = {};
      for (let item of items) {
        alreadyHave[`${item.lat}_${item.lon}`] = item;
      }
      return Object.values(alreadyHave).map(o => ({ lat: o.lat, lng: o.lon, locationId: o.locationId, locationName: o.locationName }));
    }
  }

  render() {
    const { searchForm, navigation, searchResults, vSearch, organization, businessUnit, aggParameters } = this.props;
    const appliedConstraintCount = searchForm.getAppliedConstraintCount(aggParameters.criteria);
    return (
      <div>

        <SiteHeader />

        <div className={`search-results-wrapper ${vSearch.viewTypeClass}`}>
          <StickInParent>{({ ref: sipRef }) =>
            <section className="searchbar-container search-results sticky-container" data-sticky_column ref={sipRef}>
              <Swiper config={constants.FILTER_SWIPER_PROPS}>{({ ref }) => <Observer>{() =>
                <div className="swiper-container filters-container" ref={ref}>
                  <div className="swiper-wrapper">
                    {/* ========== LOCATION ========== */}
                    {searchForm.showLocation && <Dropdown>{({ ref, isOpen, onOpen, onClose, onOpenToggle }) => <Observer>{() =>
                      <div ref={ref} className="swiper-slide ss-location" onClick={onOpenToggle}>
                        <div className="label small">{translate("location", "Standort")}</div>
                        <div className="input big">{searchForm.locationText || translate("allLocations", "All locations")}</div>

                        {<PreventParentScroll>{({ refScrollable, onScrollableWheel }) => <Observer>{() =>
                          <div className={"dropdown list" + (isOpen ? ' active' : '')} ref={refScrollable} onWheel={onScrollableWheel} onClick={event => event.stopPropagation()}>
                            {searchForm.optLocation ?
                              <ul>
                                <li>
                                  <a onClick={() => {
                                    searchForm.location = undefined;
                                    onClose();
                                  }}>{translate("chooseAllLocations", "All locations")}</a>
                                </li>
                                {searchForm.optLocation.map(option =>
                                  <li key={option.value}>
                                    <a onClick={() => {
                                      searchForm.location = option.value;
                                      onClose();
                                    }}
                                      data-value={option.value}>
                                      {option.text}
                                    </a>
                                  </li>
                                )}
                              </ul>
                              :
                              <div className="no-items-available">{translate("noItemsLoadedYet", "No items loaded yet.")}</div>}
                          </div>
                        }</Observer>}</PreventParentScroll>}
                      </div>
                    }</Observer>}</Dropdown>}



                    {/* ========== CATEGORY ========== */}
                    {searchForm.showCategory && <Dropdown>{({ ref, isOpen, onOpen, onClose, onOpenToggle }) => <Observer>{() =>
                      <div ref={ref} className="swiper-slide ss-category" onClick={onOpenToggle}>
                        <div className="label small">{translate("objectType", "Objekttyp")}</div>
                        <div className="input big">{
                          (!searchForm.categoryText || !searchForm.subcategoryText) ?
                            translate("allCategories", "All categories") :
                            <span>{searchForm.categoryText} / {searchForm.subcategoryText}</span>
                        }</div>
                        {<PreventParentScroll>{({ refScrollable, onScrollableWheel }) => <Observer>{() =>
                          <div className={"dropdown list" + (isOpen ? ' active' : '')} ref={refScrollable} onWheel={onScrollableWheel} onClick={event => event.stopPropagation()}>
                            {searchForm.optCategory ?
                              <ul>
                                <li>
                                  <a onClick={action(() => {
                                    searchForm.category = undefined;
                                    searchForm.subcategory = undefined;
                                    onClose();
                                  })} >
                                    {translate("chooseAllCategories", "All categories")}
                                  </a>
                                </li>
                                {searchForm.optCategory.map(category =>
                                  <li><b>{category.text}</b>
                                    <ul>
                                      {searchForm.optSubcategory(category.value).map(subcategory =>
                                        <li><a
                                          onClick={action(() => {
                                            searchForm.category = category.value;
                                            searchForm.subcategory = subcategory.value;
                                            onClose();
                                          })}
                                          data-value={subcategory.value}>
                                          {subcategory.text}
                                        </a></li>
                                      )}
                                    </ul>
                                  </li>
                                )}
                              </ul>
                              :
                              <div className="no-items-available">{translate("noItemsLoadedYet", "No items loaded yet.")}</div>
                            }
                          </div>
                        }</Observer>}</PreventParentScroll>}
                      </div>
                    }</Observer>}</Dropdown>}


                    {/* ========== START DATE ========== */}
                    <Dropdown>{({ ref, isOpen, onOpen, onClose, onOpenToggle }) => <Observer>{() =>
                      <div ref={ref} className="swiper-slide ss-startdate" onClick={onOpenToggle}>
                        <div className="label small">{translate("startDate", "Start date")}</div>
                        <div className="input big">{searchForm.startDate ?
                          fmtDate(searchForm.startDate) : translate("noStartDateSelected", "Kein Start Datum gewählt")}</div>
                        {<div className={"dropdown calendar" + (isOpen ? ' active' : '')} onClick={event => event.stopPropagation()}>
                          <DayPicker
                            disableBefore={moment()}
                            onDayClick={(day) => {
                              let orgTimeAtomSecs = constants.TIME_UNIT_DURATION[organization.refAllotmentTimeUnitId];
                              var isDayOrMore = (orgTimeAtomSecs >= 86400);
                              var format = isDayOrMore ? "YYYY-MM-DD" : "YYYY-MM-DDT00:00:00.000"; 
                              var startDate = moment(day).format(format);
                              if(!isDayOrMore) {
                                startDate = replaceBetween(startDate+"Z", 11, 16, organization.minPickupTime);
                              }
                              searchForm.changeStartDate(startDate);
                              onClose();
                            }}
                            selectedDays={new Date(searchForm.startDate)}
                          />
                        </div>}
                      </div>
                    }</Observer>}</Dropdown>


                    {/* ========== TIME SPAN ========== */}
                    <Dropdown>{({ ref, isOpen, onOpen, onClose, onOpenToggle }) => <Observer>{() =>
                      <div ref={ref} className="swiper-slide ss-duration" onClick={onOpenToggle}>
                        <div className="label small">{translate("diration", "Dauer")}</div>
                        <div className="input big">{searchForm.duration}{" "}{searchForm.timeUnitText}{" "}
                          {searchForm.endDate && <span>({translate('to', 'to')}{" "}{fmtDate(searchForm.endDate)})</span>}
                        </div>
                        {<div className={"dropdown duration" + (isOpen ? ' active' : '')} onClick={event => event.stopPropagation()}>
                          <div className="row">
                            <div className="label">
                              {translate("count", "Anzahl")}
                            </div>
                            <div className="input">
                              <input placeholder={translate("enterUnitsCount", "Enter units count")} value={searchForm.duration} />
                              <a className={"minus" + (searchForm.canDecDuration ? "" : " unselectable")}
                                onClick={searchForm.decDuration}><i className="fa fa-minus"></i></a>
                              <a className={"plus" + (searchForm.canIncDuration ? "" : " unselectable")}
                                onClick={searchForm.incDuration}><i className="fa fa-plus"></i></a>
                            </div>
                          </div>
                          <div className="row">
                            <div className="label">
                              {translate("timeUnit", "Time unit")}
                            </div>
                            <div className="input">
                              <input placeholder={translate("enterUnitsType", "Enter units type")} value={searchForm.timeUnitText} />
                              <a className={"minus" + (searchForm.canDecTimeUnit ? "" : " unselectable")}
                                onClick={searchForm.decTimeUnit}><i className="fa fa-minus"></i></a>
                              <a className={"plus" + (searchForm.canIncTimeUnit ? "" : " unselectable")}
                                onClick={searchForm.incTimeUnit}><i className="fa fa-plus"></i></a>
                            </div>
                          </div>
                        </div>}
                      </div>
                    }</Observer>}</Dropdown>
                  </div>

                  <div className="swiper-button-next"></div>
                  <div className="swiper-button-prev"></div>
                </div>
              }</Observer>}</Swiper>



              <div className="view-switch-container">
                <a onClick={vSearch.changeView}>
                  {/*<Flasher>*/}
                  <i className="fa fa-th-large" aria-hidden="true"></i> {/*<i className="fa fa-caret-down" aria-hidden="true"></i>*/}
                  {/*</Flasher>*/}
                </a>
              </div>
            </section>
          }</StickInParent>
          <section className="search-results-container">
            <div className="row">
              {vSearch.showsMap && <StickInParent config={{ offset_top: 91 }}>{({ ref: sipRef }) =>
                <div className="column-5 map-container" data-sticky_column ref={sipRef}>
                  <div className="row">
                    <div className="column-12">
                      {vSearch.showsMap && <Observer>{() => {
                        return <GoogleMap
                          containerElement={<div className="q" />}
                          mapElement={<div id="map"></div>}
                          {...{
                            pointsToShow: this.allCoords,
                            zoom: 7,
                            mapTypeControl: false,
                            scrollwheel: false,
                            streetViewControl: false,
                            navigationControl: true,
                            zoomControl: true,
                            panControl: true,
                            zoomControlOptions: {
                              style: google.maps.ZoomControlStyle.SMALL
                            },
                            mapTypeId: google.maps.MapTypeId.ROADMAP
                          }}
                          defaultOptions={{
                            styles: [
                              {
                                stylers: [
                                  { visibility: "on" },
                                  { saturation: -100 },
                                ]
                              }
                            ]
                          }}
                          defaultCenter={{ lat: 47.44189058, lng: 8.43409091 }}
                          myMarkers = {this.allCoords}
                        >
                          {this.allCoords.map(o => {
                            return <MarkerWithInfoWindow
                              key={o.lat + '_' + o.lng}
                              position={{ lat: o.lat, lng: o.lng }}
                              title={o.locationName}
                              canShow={searchForm.location == o.locationId}
                              onClick={() => { searchForm.location = o.locationId; this.shownPointLat = o.lat; this.shownPointLon = o.lng; }}
                              icon={{
                                path: MarkerIconSVG,
                                fillColor: (this.shownPointLat === o.lat && this.shownPointLon === o.lng) ? organization.settings.primaryColor || '#000000' : '#FFFFFF',
                                fillOpacity: 1,
                                strokeWeight: 2,
                                size: new google.maps.Size(30, 40),
                                origin: new google.maps.Point(0, 0),
                                anchor: new google.maps.Point(15, 40),
                                scaledSize: new google.maps.Size(30, 40),
                              }}>
                              <div>
                                <h4>{o.locationName}</h4>
                                <a onClick={() => { searchForm.location = undefined; this.shownPointLat = undefined; this.shownPointLon = undefined; }}>{translate("showAll", "Alle anzeigen")}</a>
                              </div>
                            </MarkerWithInfoWindow>
                          })}
                        </GoogleMap>
                      }}</Observer>}
                    </div>
                  </div>
                </div>
              }</StickInParent>}

              <div className="column-7 teasers-container">
                <div className="row">
                  {searchResults.filteredItems.length === 0 &&
                    <div className="no-items-found">
                      {translate("thereAreNoResults", "There were no results for your search.")}
                    </div>
                  }
                  {vSearch.slicedSearchResults(searchResults.filteredItems).map(result => {
                    return <div key={result.id} className="column-4"
                      onMouseOver={() => this.showPoint(result.lat, result.lon)}
                      onMouseOut={() => this.showPoint()}>
                      <a className="product-container" href={navigation.hrefObjectDetails(result.id)}>
                        <figure className="product-image">
                          <div className="spacer"></div>
                          <Focuspoint
                            src={result.thumbnailUrl}
                            imageW={756}
                            imageH={415}
                            focusX={0.0}
                            focusY={0.0}
                            reCalcOnWindowResize={true}
                          />
                        </figure>
                        <div className="product-details">
                          <div className="product-name biggest">
                            {result.name}
                          </div>
                          {(result.resultPriceFrom !== null) && <div className="product-price">
                            <span className="from">{translate("fromPrice", "Ab")}</span>
                            <span className="amount">{result.currencyName}&nbsp;{fmtPrice(result.resultPriceFrom)}</span>
                            <span className="duration">/ {result.timeUnitForPrice}</span>
                          </div>}
                          <div className="product-location">
                            <i className="fa fa-map-marker" aria-hidden="true"></i> {result.businessUnitName}
                          </div>
                        </div>
                      </a>
                    </div>
                  })}
                </div>
                {vSearch.canLoadMore && <div className="row load-more">
                  <div className="column-12">
                    <button onClick={vSearch.loadMore}>{translate("loadMore", "Mehr laden")} <i className="fa fa-refresh"></i></button>
                  </div>
                </div>}
              </div>

            </div>
          </section>

        </div>

        <SiteFooter />

      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/visual/view/Search.js